import { InputBase, InputBaseProps, Text, TextInputProps } from '@mantine/core';

import { IconMailFilled } from '@tabler/icons-react';

import classes from './EmailInput.module.css';

type TEmailInputProps = {
	onChange: (phoneNumber: string) => void;
} & TextInputProps &
	InputBaseProps;

export const EmailInput = ({ onChange, ...rest }: TEmailInputProps) => {
	return (
		<InputBase
			classNames={classes}
			placeholder="ivan.ivanov@email.ru"
			rightSection={<IconMailFilled opacity={0.5} />}
			label={
				<Text c="#667085" fz={12} fw={500} lh="normal" tt="uppercase">
					Электронная почта
				</Text>
			}
			labelProps={{
				display: 'flex',
			}}
			size="md"
			onChange={onChange}
			{...rest}
		/>
	);
};
// /^\S*@?\S*$/
